import React, { useEffect, useState } from 'react'
import ActionButton from '../../components/Buttons/ActionButton'

import { ReactComponent as ArrowDownicon } from '../../assets/icons/arrow_down.svg'
import { ReactComponent as PlayIcon } from '../../assets/icons/play.svg'
import { NavLink } from 'react-router-dom'
import UserService from '../../services/UserService'

type Props = {
    input: any
    onChange?: any
}

const ActionInput = (props:Props) => {

    const [input, setInput] = useState(props.input)

    const handleOnChange = (value: any) => {
        var newInput = {...input, value: value}
        props.onChange(newInput);
        setInput(newInput);
    }

    return(

        <div className="action-variable">
            <div className="action-label">{input.label}</div>
            <input type="text" value={input.value} onChange={(e)=> handleOnChange(e.target.value)} className="action-input" ></input>
        </div>
               
    )
    
}

export default ActionInput;
